export default __webpack_public_path__ + "7100e47c8162b0fa1e7756263eecfbc2.png";